export const handleSearchInputSelect = (
   fieldName,
   value,
   setValue,
   clearErrors
) => {
   setValue(fieldName, value);
   clearErrors(fieldName);
};
